<app-kontable
              title = "{{supplier.code}} - {{ 'common.supplier_brand_title' | translate }}"
              [columns] = "['id', 'brand_id', 'brand_name']"
              [titles] = "['common.id', 'common.brand_id', 'common.brand_name']"
              [showInfoButton]="false"
              [showRecoverButton]="false"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [konPermissions]="perm"
              [source]="brands"
              (onAdd)="showAddOrEditDialog($event)"
              (onRemove)="delete($event)">
</app-kontable>

<p-dialog *ngIf="svc.editing_supplier_brand"
          [width]="500"
          header="{{modalTitle}}"
          [(visible)]="svc.editing_supplier_brand"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

    <app-supplier-brand-form
            (onAddElement)="onAddElement($event)">
    </app-supplier-brand-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-brand/supplier-brand.component.html